import React from 'react';
import {
  Box,
  Divider,
  IconButton,
  FormControlLabel,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import CachedIcon from '@mui/icons-material/Cached';
import SortIcon from '@mui/icons-material/Sort';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { useTheme } from '@mui/material/styles';

import CurrentTableContext from 'components/shared/CustomTable/context';

const CustomTableHeader = () => {
  const { palette } = useTheme();
  const {
    title,
    dense,
    disabled,
    fullscreen,
    configuration,
    handleReload,
    handleChangeDense,
    toggleFullscreen,
    handleOpenConfigModal,
    handleOpenSortModal,
    sortColumns,
    onCopy,
  } = React.useContext(CurrentTableContext);

  const {
    showTableHeader,
    showConfigurationColumn,
    showConfigurationSize,
    showConfigurationFullscreen,
    showConfigurationRefresh,
    showConfigurationSortColumn,
    showConfigurationCopy,
  } = configuration;

  if (!showTableHeader) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ backgroundColor: palette.table.header }}
    >
      <Box display="flex" alignItems="center">
        {showConfigurationRefresh ? (
          <IconButton
            aria-label="CachedIcon"
            size="small"
            onClick={handleReload}
          >
            <CachedIcon />
          </IconButton>
        ) : null}
        <>
          {title ? (
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 'normal', marginLeft: 2 }}
            >
              {title}
            </Typography>
          ) : null}
        </>
      </Box>
      <Box display="flex" alignItems="center">
        {showConfigurationSize ? (
          <Box display="flex" alignItems="center">
            <Typography
              sx={{ marginRight: 4 }}
              variant="subtitle2"
              fontWeight="normal"
            >
              Modo compacto
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  color="secondary"
                  checked={dense}
                  onChange={handleChangeDense}
                />
              }
              label=""
            />
          </Box>
        ) : null}

        {showConfigurationSortColumn ? (
          <IconButton
            aria-label="SortIcon"
            size="small"
            onClick={handleOpenSortModal}
            color={sortColumns.length ? 'primary' : undefined}
          >
            <SortIcon />
          </IconButton>
        ) : null}

        {showConfigurationColumn ? (
          <IconButton
            aria-label="settingsIcon"
            size="small"
            onClick={handleOpenConfigModal}
            disabled={disabled}
          >
            <ViewColumnIcon />
          </IconButton>
        ) : null}

        {showConfigurationCopy && onCopy ? (
          <>
            <Divider
              orientation="vertical"
              sx={{ width: '2px', height: '20px' }}
            />
            <Tooltip title="Copiar tabla" disableInteractive>
              <IconButton aria-label="copyTable" size="small" onClick={onCopy}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </>
        ) : null}
        {showConfigurationFullscreen ? (
          <>
            <Divider
              orientation="vertical"
              sx={{ width: '2px', height: '20px' }}
            />
            <Tooltip
              title={fullscreen ? 'Minimizar' : 'Maximizar'}
              disableInteractive
            >
              <IconButton
                aria-label="settingsIcon"
                size="small"
                onClick={toggleFullscreen}
              >
                {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Tooltip>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default React.memo(CustomTableHeader);
